<section
  class="rounded-lg border border-greyscale-200 bg-white"
  [class.p-4]="compact()"
  [class.p-6]="!compact()"
>
  <div
    class="flex flex-col gap-6"
    [class.lg:flex-row]="!compact()"
    [class.lg:items-center]="!compact()"
    [class.lg:gap-10]="!compact()"
  >
    <div class="flex items-center gap-4">
      <app-journey-progress-ring
        [percent]="overallPercent()"
        [size]="compact() ? 68 : 96"
        [strokeWidth]="compact() ? 10 : 9"
      />

      <div class="min-w-0">
        @if (!compact()) {
          <p
            class="text-paragraph-xs-med uppercase tracking-wide text-primary-600"
          >
            {{ "help.onboarding.journey.title" | transloco }}
          </p>
        }

        <h2
          class="text-greyscale-950"
          [class.text-heading-2]="!compact()"
          [class.text-heading-4]="compact()"
        >
          {{ levelTitleKey() | transloco }}
        </h2>

        <p class="mt-0.5 text-paragraph-s-reg text-greyscale-600">
          <span class="font-semibold text-greyscale-800">
            {{
              "help.onboarding.journey.levelLabel" | transloco: levelParams()
            }}
          </span>
          ·
          {{
            "help.onboarding.journey.progressSummary"
              | transloco: summaryParams()
          }}
        </p>

        @if (!compact()) {
          <p class="mt-2 max-w-xl text-paragraph-s-reg text-greyscale-600">
            {{ "help.onboarding.journey.description" | transloco }}
          </p>
        }
      </div>
    </div>

    <!-- The two tracks stay visible: they are counted separately on purpose. -->
    <div
      class="flex flex-col gap-3"
      [class.lg:ml-auto]="!compact()"
      [class.lg:w-80]="!compact()"
      [class.shrink-0]="!compact()"
    >
      @for (track of tracks(); track track.titleKey) {
        <div class="flex flex-col gap-1.5">
          <div class="flex items-center justify-between gap-2">
            <span
              class="flex items-center gap-2 text-paragraph-s-med text-greyscale-800"
            >
              <lucide-icon
                [name]="track.icon"
                class="text-primary-500"
                [size]="15"
              />
              {{ track.titleKey | transloco }}
            </span>
            <span class="text-paragraph-s-bold text-greyscale-900">
              {{ track.progress.completed }}/{{ track.progress.total }}
            </span>
          </div>
          <div class="h-2 w-full overflow-hidden rounded-full bg-greyscale-200">
            <div
              class="h-full rounded-full bg-primary-500 transition-all duration-700 ease-out"
              [style.width.%]="percent(track.progress)"
            ></div>
          </div>
          @if (!compact()) {
            <p class="text-paragraph-xs-reg text-greyscale-500">
              {{ track.hintKey | transloco }}
            </p>
          }
        </div>
      }
    </div>
  </div>

  @if (phases().length > 0) {
    <div
      class="border-t border-greyscale-100"
      [class.mt-4]="compact()"
      [class.pt-4]="compact()"
      [class.mt-6]="!compact()"
      [class.pt-6]="!compact()"
    >
      <app-journey-path
        [phases]="phases()"
        [compact]="compact()"
        (phaseSelected)="phaseSelected.emit($event)"
      />
    </div>
  }
</section>
